import LmsTable from "../ui/LmsTable";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";

export const DocuSignTable = () => {
  return (
    <>
      <LmsTable
        actionButtons={[
          "export",
          {
            action: "submitselected",
            text: "Void Envelope",
            submitSuffix: "document/docusign-status/void-envelope",
            method: "PUT",
            icon: GlobalConstants.Icons.BAN,
            confirmationMessage:
              "Are you sure you want to void the selected Document(s)?",
            isDisabled: (checkedItems) => checkedItems?.length === 0,
          },
        ]}
        apiSuffix="document/docusign-statuses"
        sortable={["Created On"]}
        columnLabelsDictionary={{
          description: "Decline Reason"
        }}
        columnClickOptions={{
          envelopeAttachment: {
            idProp: "id",
            downloadPath: "document/docusign-statuses/{id}/download",
          },
          name: {
            idProp: "id",
            path: "documents-docusign-status/view"
          },
        }}
      />
    </>
  );
};

const addDocuSignStatusFields = (myForm: BCFormController) => {
  myForm.addCenteredGroup([
    myForm.getDisplayField("Name"), 
    myForm.getDisplayField("Table Name")
  ]);

  myForm.addCenteredGroup([
    myForm.getDisplayField("Loan"),
    myForm.getDisplayField("Envelope No")
  ]);

  myForm.addCenteredGroup([
    myForm.getDisplayField("Envelope Status"),
    myForm.getLinkField("Envelope Attachment", { 
      link: `document/docusign-statuses/${myForm?.initialValues?.id}/download`,
      linkName: myForm?.initialValues?.envelopeAttachmentFileName, 
      linkType: "DownloadFile",
      method: "GET",
    })
  ], { isHiddenFunc: ({ inputs }) => !inputs?.isEnvelopeAttachmentAvailable });

  myForm.addCenteredGroup([
    myForm.getDisplayField("Envelope Status"),
    myForm.getLabelField("Envelope Attachment")
  ], { isHiddenFunc: ({ inputs }) => inputs?.isEnvelopeAttachmentAvailable });

  myForm.addCenteredGroup([
    myForm.getDisplayField("Envelope Attachment File Name"),
    myForm.getDisplayField("Recipient", { name: "completedRecipients" })
  ]);

  myForm.addCenteredGroup([
    myForm.getCheckboxField("Is Active", { disabled: true })
  ]);

  myForm.addCenteredGroup([
    myForm.getTextareaField("Decline Reason", { name: "description", disabled: true })
  ]);

  return myForm;
};

const ViewForm = ({ id }) => {
  const [{ data }] = useFetchData(`document/docusign-statuses/${id}`);
  const myForm = addDocuSignStatusFields(new BCFormController(data, { 
    values: { isEnvelopeAttachmentAvailable: data?.envelopeAttachment },
    submitSuffix: "document/docusign-sender-receiver", 
    blankWidth: 2 
  }));
  const formActions = ["close"];
  return <LmsFormGenerator myForm={myForm} actions={formActions}  />;
};

const LmsDocuSignStatus  = ({ ...props }) => {
  const { params = {}, history } = props;
  const {  isMainPage, isActionAllowed, isView, id }  = useParseRouteActions(params);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <DocuSignTable />}
      {isView && <ViewForm id={id} />}
    </>
  );
};

export default LmsDocuSignStatus;